import { useState } from "react";

export default function SubscriptionTracker() {
  const [items, setItems] = useState([
    { id: 1, name: "Streaming", cost: 15 },
    { id: 2, name: "Gym", cost: 35 },
  ]);

  const updateItem = (id, key, value) => {
    setItems((prev) => prev.map((item) => (item.id === id ? { ...item, [key]: value } : item)));
  };

  const addItem = () => {
    setItems((prev) => [...prev, { id: Date.now(), name: "", cost: 0 }]);
  };

  const removeItem = (id) => {
    setItems((prev) => prev.filter((item) => item.id !== id));
  };

  const monthlyTotal = items.reduce((sum, item) => sum + (Number(item.cost) || 0), 0);
  const annualTotal = monthlyTotal * 12;

  return (
    <main style={{ padding: "120px 0 80px" }}>
      <div className="container">
        <h1 style={{ fontFamily: "Fraunces, serif", fontSize: 40, marginBottom: 8 }}>Subscription Cost Tracker</h1>
        <p style={{ color: "var(--t2)", marginBottom: 20 }}>Track recurring subscriptions and see your monthly and annual total costs.</p>

        <div className="card-base" style={{ padding: 18, marginBottom: 18 }}>
          {items.map((item) => (
            <div key={item.id} style={{ display: "grid", gridTemplateColumns: "2fr 1fr auto", gap: 12, alignItems: "end", marginBottom: 12 }}>
              <label style={{ marginBottom: 0 }}>
                <div className="font-mono" style={{ fontSize: 11, color: "var(--t3)", marginBottom: 6 }}>Name</div>
                <input className="input" value={item.name} onChange={(e) => updateItem(item.id, "name", e.target.value)} placeholder="Subscription name" />
              </label>
              <label style={{ marginBottom: 0 }}>
                <div className="font-mono" style={{ fontSize: 11, color: "var(--t3)", marginBottom: 6 }}>Monthly cost</div>
                <input className="input" type="number" value={item.cost} onChange={(e) => updateItem(item.id, "cost", e.target.value)} placeholder="0" />
              </label>
              <button className="btn btn--ghost" onClick={() => removeItem(item.id)} aria-label="Remove subscription" style={{ marginTop: 24 }}>Remove</button>
            </div>
          ))}

          <button className="btn btn--primary" onClick={addItem}>Add subscription</button>
        </div>

        <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: 12 }}>
          <div className="card-base" style={{ padding: 18 }}>
            <div className="font-mono" style={{ fontSize: 11, color: "var(--t3)", marginBottom: 8 }}>Total monthly cost</div>
            <div style={{ fontFamily: "Fraunces, serif", fontSize: 24 }}>${monthlyTotal.toFixed(2)}</div>
          </div>
          <div className="card-base" style={{ padding: 18, border: "2px solid var(--emerald)" }}>
            <div className="font-mono" style={{ fontSize: 11, color: "var(--t3)", marginBottom: 8 }}>Annual cost</div>
            <div style={{ fontFamily: "Fraunces, serif", fontSize: 24, color: "var(--emerald)" }}>${annualTotal.toFixed(2)}</div>
          </div>
        </div>
      </div>
    </main>
  );
}
